import { modelOptions, prop } from '@typegoose/typegoose';

@modelOptions({ schemaOptions: { collection: 'urls' }, options: { customName: 'urls' } })
export class UrlsModel {
  @prop({ required: true })
  name: string;

  @prop({ required: true })
  url: string;

  @prop({ required: true })
  server: string;

  @prop({ required: true })
  port: number | null;

  @prop({ required: true })
  securePort: number | null;

  @prop({ required: false })
  certificate_fingerprint: string;
}
